module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo24-48cb54cceeea80248c13c59b6bd9baac.jpg";